import type { FaireProductEntity } from "../../entity_types/product";

export const p_mf37ezvmfw: FaireProductEntity = {
  token: "p_mf37ezvmfw",
  type: "product",
  name: "Kids Bible Memory Cards Christian gift kids Christian gift",
  brandToken: "b_5sfnb3y1",
  brandName: "Aspen Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/806fe83c44035ac5b4ca7e3abda24e8676be60472e066be1e8de9461cf73f93b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ef490ec487ad0817c2e982233b7b8014d80b3256b3a9e2d50c5c7cd6c181f8e.png",
    "https://cdn.faire.com/fastly/829a832da1e07c98486420905e452e23aeb59ae0bc446bf509fde3c31cd88f0d.png",
    "https://cdn.faire.com/fastly/928321560003c6936cac9ed21af3759866ade8cb46706d47c6d61bbf655f3940.jpeg",
    "https://cdn.faire.com/fastly/6d07135c0798dc3264e4c5963d85cb8488c9ebd51ab774cd022d41a2c1a525ce.jpeg",
    "https://cdn.faire.com/fastly/f2ea0c8f5db805404d3e969cc9ed254e3b56e9a911800dc16a9e6c37387cb400.jpeg",
    "https://cdn.faire.com/fastly/678081d6636459997ea5674cf2cbf30f7f662916b61e2207024ad482803afaa0.png",
  ],
  priceDollars: 9.7,
  description:
    "Christian gift and resource for kid's faith and homeschool products. Introducing our \"Top 52 Bible Verses every kid needs to know\" collection. Perfect for homeschool, kid's bible study, Sunday School or children's ministry gifts. Makes the perfect Easter Basket gift or first communion gift. \n\nHelp your little ones memorize Scripture with this vibrant card set featuring 52 essential Bible verses designed just for kids. Each card showcases bright, engaging artwork that makes God's Word come alive and fun to learn. \n\nPrinted on premium matte cardstock with verses on both sides, these pocket-sized cards (5.5\" x 4.5\") are perfect for daily devotions, car rides, or quiet time. Choose between two cheerful colorways—Pinks + Red or Blue + Red—and watch your kids hide God's Word in their hearts, one verse at a time.\n\nProudly designed in the USA, Printed in China.\n\nSize: 5.5x4.5\nPackaging: Shrinkwrapped with detailed back sticker for card preview.",
  tags: [],
  msrpDollars: 19.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:52.463Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
